import { rosterKey } from '../workspace/ids';

export { rosterKey };

export function studentRosterKey(student) {
  return rosterKey(student.schoolId, student.branchId);
}

export function rosterHasStudents(students, schoolId, branchId) {
  const key = rosterKey(schoolId, branchId);
  return students.some(s => studentRosterKey(s) === key);
}

export function mergeRosterStudents(students, schoolId, branchId, mapped) {
  const key = rosterKey(schoolId, branchId);
  const others = students.filter(s => studentRosterKey(s) !== key);
  return [...others, ...mapped];
}

export function mapStudentFromApi(s, schoolId, branchId) {
  return {
    id: String(s.id),
    name: s.full_name || `${s.first_name || ''} ${s.last_name || ''}`.trim(),
    grade: s.user_school_details?.grade ? `Grade ${s.user_school_details.grade}` : (s.grade || ''),
    schoolId: String(schoolId),
    branchId: branchId ? String(branchId) : '',
    apiData: s,
  };
}

export function resolveStudent(id, liveStudents = [], nominationFallback = null) {
  if (id == null || id === '') return null;
  const key = String(id);
  const found = liveStudents.find(s => String(s.id) === key);
  const nameFromNomination = resolveNameFromNomination(key, nominationFallback);
  return {
    id: key,
    name: found?.name || nameFromNomination || `Student #${key}`,
    grade: found?.grade || '',
  };
}

export function resolveStudents(ids, liveStudents = [], nominationFallback = null) {
  return (ids || [])
    .filter(id => id != null && id !== '')
    .map(id => resolveStudent(id, liveStudents, nominationFallback));
}

function resolveNameFromNomination(id, nomination) {
  if (!nomination) return null;
  const pairs = [
    [nomination.chairId, nomination.chairName],
    ...(nomination.presenterIds || []).map((pid, idx) => [pid, nomination.presenterNames?.[idx]]),
    ...(nomination.mentorIds || []).map((mid, idx) => [mid, nomination.mentorNames?.[idx]]),
    ...(nomination.challengerIds || []).map((cid, idx) => [cid, nomination.challengerNames?.[idx]]),
  ];
  const hit = pairs.find(([studentId]) => String(studentId) === String(id));
  return hit?.[1] || null;
}